import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { getAccessToken, getTokenExchangePromise, isLogoutPage, login } from '../oauth2Service.js';

/**
 * Invisible component that triggers auth initialization.
 * On mount:
 * 1. Waits for any in-progress token exchange (started at module load) to complete
 * 2. If token available in sessionStorage, calls fetchCurrentUser
 * 3. If no token at all, redirects to backend /oauth2/login
 */
const AuthInitializer = ({ pagoAuth2Actions }) => {
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) return;
    if (!pagoAuth2Actions?.fetchCurrentUser) return;

    hasInitialized.current = true;

    const init = async () => {
      // Wait for the token exchange that was started at module load (index.js)
      const exchangePromise = getTokenExchangePromise();
      if (exchangePromise) {
        await exchangePromise;
      }

      if (isLogoutPage()) return;

      const token = getAccessToken();
      if (token) {
        pagoAuth2Actions.fetchCurrentUser();
      } else {
        login();
      }
    };
    init();
  }, [pagoAuth2Actions]);

  return null;
};

AuthInitializer.propTypes = {
  pagoAuth2Actions: PropTypes.object,
};

export default AuthInitializer;
